import { useAuth } from "@/context/AuthContext";

export default function StaffDashboard() {
  const { user } = useAuth();
  return (
    <div className="p-8" data-testid="staff-dashboard">
      <h1 className="text-2xl font-semibold text-slate-900" style={{ fontFamily: "Work Sans" }}>
        Staff Dashboard
      </h1>
      <p className="text-slate-600 mt-2">
        Signed in as <span className="font-medium">{user?.name || user?.email}</span>
        {user?.role ? <> · <span className="uppercase tracking-wider text-xs">{user.role}</span></> : null}
      </p>
    </div>
  );
}
